<template lang="pug">
.flex.flex-col.w-full(
  :class="[compact ? 'gap-1 lg_gap-0' : 'gap-6']"
  v-if="!audioDoc"
)
  uc-animate(:animate="animate" v-for="(toggle, i) in screen.toggles")
    .toggle.bg-paper.corners.surface.text-center.flex.flex-col.items-center.lg_flex-row.gap-4.justify-center.lg_text-left.lg_gap-8(
      :class="[compact ? 'p-3 lg_p-3 lg_px-4 lg_border-b lg_border-b-gray-200 lg_dark_border-b-gray-700' : 'p-6 px-8', { 'gap-8 lg_gap-16': isEditModeActive }]"
      :id="`toggle_${screen.id}_${i}`"
    )
      uc-editable.flex-1.prose-stack(
        :edit-path="getToggleEditPath(i)"
        :k="toggle.id ? `${toggle.id}.${toggleAnswer(i)}` : null"
        :text="getToggleText(i)"
      )

      .inline-flex.flex-wrap.justify-center.gap-3.lg_gap-5.lg_ml-auto.flex-none.items-center(
        uc-word-skip=""
      )
        //- toggle-yes option
        .relative(
          :class="{ 'flex flex-col items-center gap-4': isEditModeActive, 'w-full': !largerThanSm }"
        )
          //- separate edit-only text element outside of the toggle button
          .text-base.bg-gray-200.text-gray-900.dark_bg-gray-900.dark_text-gray-200.p-2.px-6.corners(
            v-if="isEditModeActive && i === 0"
          )
            uc-editable(
              :edit-path="`${editPath}.toggle-yes`"
              :k="`${screen.id}.toggle-yes`"
              :text="toggleYes"
            )

          button.ripple.w-full.block.focus-visible_ring-4.text-base.bg-gray-200.text-gray-900.dark_bg-gray-900.dark_text-gray-200.p-2.px-6.corners.prose-stack(
            :class="{ 'opacity-50': toggleCompleted[`toggle_${screen.id}_${i}`] && !toggle['1'], 'lg_p-1 lg_px-5': compact }"
            :data-toggle-id="`toggle_${screen.id}_${i}`"
            :disabled="isEditModeActive || toggleCompleted[`toggle_${screen.id}_${i}`]"
            @click="clickHandler"
            :aria-label="`${getToggleText(i)}:  ${toggleYes}`"
            class="ripple_bg-gray-500/10"
            data-toggle-value="yes"
            v-else=""
            :data-sfx="toggle['1'] && toggleCompleted[`toggle_${screen.id}_${i}`] && suspend.questionOptions[`toggle_${screen.id}_${i}_yes`] ? 'correct' : 'no'"
          )
            uc-text(
              :k="screen.id + '.toggle-yes'"
              :text="toggleYes"
            )

          transition-pop(:duration="0.3")
            .feedback-icon.w-5.h-5.bg-emerald-500.text-sm.text-white.flex.items-center.justify-center.rounded-full.absolute.-inset-2(
              v-if="toggle['1'] && toggleCompleted[`toggle_${screen.id}_${i}`] && suspend.questionOptions[`toggle_${screen.id}_${i}_yes`]"
              aria-live="polite"
              aria-atomic="true"
              role="status"
            )
              uc-icon(icon="mdi:check-thick")
              uc-text.sr-only(text="correct selected")
          transition-pop(:duration="0.3")
            .feedback-icon.w-5.h-5.bg-red-500.text-sm.text-white.flex.items-center.justify-center.rounded-full.absolute.-inset-2(
              v-if="!toggle['1'] && toggleCompleted[`toggle_${screen.id}_${i}`] && suspend.questionOptions[`toggle_${screen.id}_${i}_yes`]"
              aria-live="polite"
              aria-atomic="true"
              role="status"
            )
              uc-icon(icon="mdi:close-thick")
              uc-text.sr-only(text="incorrect selected")

        //- toggle-no option
        .relative(
          :class="{ 'flex flex-col items-center gap-4': isEditModeActive, 'w-full': !largerThanSm }"
        )
          //- separate edit-only text element outside of the toggle button
          .text-base.bg-gray-200.text-gray-900.dark_bg-gray-900.dark_text-gray-200.p-2.px-6.corners(
            v-if="isEditModeActive && i === 0"
          )
            uc-editable(
              :edit-path="`${editPath}.toggle-no`"
              :k="`${screen.id}.toggle-no`"
              :text="toggleNo"
            )

          button.ripple.w-full.block.focus-visible_ring-4.text-base.bg-gray-200.text-gray-900.dark_bg-gray-900.dark_text-gray-200.p-2.px-6.corners.prose-stack(
            :class="{ 'opacity-50': toggleCompleted[`toggle_${screen.id}_${i}`] && !toggle['0'], 'lg_p-1 lg_px-5': compact }"
            :data-toggle-id="`toggle_${screen.id}_${i}`"
            :disabled="isEditModeActive || toggleCompleted[`toggle_${screen.id}_${i}`]"
            @click="clickHandler"
            :aria-label="`${getToggleText(i)}:  ${toggleNo}`"
            class="ripple_bg-gray-500/10"
            data-toggle-value="no"
            :data-sfx="toggle['0'] && toggleCompleted[`toggle_${screen.id}_${i}`] && suspend.questionOptions[`toggle_${screen.id}_${i}_no`] ? 'correct' : 'no'"
            v-else=""
          )
            uc-text(
              :k="screen.id + '.toggle-no'"
              :text="toggleNo"
            )

          transition-pop(:duration="0.3")
            .feedback-icon.w-5.h-5.bg-emerald-500.text-sm.text-white.flex.items-center.justify-center.rounded-full.absolute.-inset-2(
              v-if="toggle['0'] && toggleCompleted[`toggle_${screen.id}_${i}`] && suspend.questionOptions[`toggle_${screen.id}_${i}_no`]"
              aria-live="polite"
              aria-atomic="true"
              role="status"
            )
              uc-icon(icon="mdi:check-thick")
              uc-text.sr-only(text="correct selected")
          transition-pop(:duration="0.3")
            .feedback-icon.w-5.h-5.bg-red-500.text-sm.text-white.flex.items-center.justify-center.rounded-full.absolute.-inset-2(
              v-if="!toggle['0'] && toggleCompleted[`toggle_${screen.id}_${i}`] && suspend.questionOptions[`toggle_${screen.id}_${i}_no`]"
              aria-live="polite"
              aria-atomic="true"
              role="status"
            )
              uc-icon(icon="mdi:close-thick")
              uc-text.sr-only(text="incorrect selected")

      uc-preload-sfx(name="correct")
      uc-preload-sfx(name="no")
      div(v-if="wordDoc && !audioDoc" uc-word-only="")
        | &nbsp;&nbsp;&nbsp;
        uc-text(
          :k="screen.id + '.toggle-yes'"
          :text="toggleYes"
          :uc-word-bold="toggle['1'] && highlightAnswers ? true : null"
        )
        | &nbsp; &frasl; &nbsp;
        uc-text(
          :k="screen.id + '.toggle-no'"
          :text="toggleNo"
          :uc-word-bold="toggle['0'] && highlightAnswers ? true : null"
        )

.toggle__feedback.flex-1.fade-in(
  ref="feedbackRef" 
  v-if="screen.feedback"
  aria-live="polite"
  aria-atomic="true"
  role="status"
  )
  audio-marker(:name="`${screen.id}-feedback`")

  transition-expand(:delay="0.5" :duration="0.75" scroll="")
    .toggle__feedback-content.outline-2.block(
      v-if="allTogglesCompleted || wordDoc || audioDoc"
    )
      //- expose these strings for the translate script
      //- text="Feedback"
      //- text="That’s right!"
      //- text="Not quite."
      uc-text.prose.md_prose-lg.text-primary-700.dark_text-primary-300.font-bold.italic.feedback-heading.mb-4(
        :class="[{ 'mx-auto': screen.center }, screen.styles?.question]"
        :k="wordDoc ? 'Feedback' : allTogglesCorrect ? 'That’s right!' : 'Not quite.'"
        :text="wordDoc ? 'Feedback' : allTogglesCorrect ? 'That’s right!' : 'Not quite.'"
        type="p"
        uc-dont-read=""
        v-if="!wordDoc && !audioDoc"
      )

      //- feedback text
      uc-editable.prose.md_prose-base(
        :k="`${screen.id}.feedback`"
        :editPath="`${editPath}.feedback`"
        :text="screen.feedback"
      )
</template>

<script setup lang="ts">
import { computed, nextTick, inject, watch, unref, toRef } from 'vue';
import { set, setCompleted } from '../lib/SCORM';
import useSuspend from '../lib/useSuspend';
import useTheme from '../stores/useTheme';
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';
import isQuizPage from '../lib/isQuizPage';
import gsap from 'gsap';
import { saveInsightsData } from '../lib/insightsData';
import useScreenAudio from '../lib/useScreenAudio';
import toggleSchema from '../lib/screen-schemas/screen-toggle.schema';

type Toggle = {
  0?: string;
  1?: string;
  // npm run translate will generate an ID
  id?: string;
};

const props = defineProps<{
  screen: UcScreen & {
    'toggle-yes': string;
    'toggle-no': string;
    'toggle-thin': boolean;
    toggles: Toggle[];
    feedback: string;
  };
  editPath: string;
}>();

const theme = useTheme();
const { playSlot } = useScreenAudio(toRef(props, 'screen'), toggleSchema);

const compact = computed(() => theme.value['variant-toggle'] === 'compact');

const animate = computed(
  () => props.screen['animate-toggle'] || theme.value['animate-toggle']
);

const toggleYes = computed(() => props.screen['toggle-yes']);
const toggleNo = computed(() => props.screen['toggle-no']);
const suspend = useSuspend();
const audioDoc = inject('audioDoc');
const wordDoc = unref<boolean>(inject('wordDoc'));
const isEditModeActive = inject('isEditModeActive') as Ref<boolean>;
const toggleAnswer = index => (props.screen.toggles[index]['0'] ? 0 : 1);
const breakpoints = useBreakpoints(breakpointsTailwind);
const largerThanSm = breakpoints.greater('sm');
const pageId = inject('pageId') as object;
const highlightAnswers = inject('highlightAnswers') as boolean;
const sectionId = inject('sectionId') as string;

const toggleCompleted = computed(() => {
  const output = {};
  const id = props.screen.id;

  props.screen.toggles.forEach((t, i) => {
    const toggleId = `toggle_${id}_${i}`;
    output[toggleId] = suspend.completed[toggleId];
  });

  return output;
});

const allTogglesCompleted = computed(() => {
  const id = props.screen.id;
  let allComplete = true;
  let i = props.screen.toggles.length;

  while (i-- && allComplete) {
    const toggleId = `toggle_${id}_${i}`;

    if (!suspend.completed[toggleId]) {
      allComplete = false;
    }
  }

  return allComplete;
});

const allTogglesCorrect = computed(() => {
  let allCorrect = true;
  props.screen.toggles.forEach((t, i) => {
    const toggleCorrect =
      (t['1'] &&
        suspend.questionOptions[`toggle_${props.screen.id}_${i}_yes`]) ||
      (t['0'] && suspend.questionOptions[`toggle_${props.screen.id}_${i}_no`]);
    if (!toggleCorrect) {
      allCorrect = false;
    }
  });

  return allCorrect;
});

const clickHandler = async e => {
  const toggleId = e.currentTarget.dataset.toggleId;
  setCompleted(toggleId);
  set(
    `questionOptions.${toggleId}_${e.currentTarget.dataset.toggleValue}`,
    true
  );

  await nextTick();

  if (allTogglesCompleted.value) {
    setCompleted(props.screen.id);

    await nextTick();

    set(`correctQuestions.${props.screen.id}`, allTogglesCorrect.value);

    await new Promise(r =>
      gsap.delayedCall(props.screen.feedback ? 1 : 0.5, r)
    );

    setCompleted(sectionId);

    saveInsightsData(props.screen, {
      correct: allTogglesCorrect.value
    });

    if (props.screen.feedback) playSlot('feedback');
  }
};

function getToggleEditPath(index) {
  return `${props.editPath}.toggles.${index}.${toggleAnswer(index)}`;
}

function getToggleText(index) {
  return props.screen.toggles[index][toggleAnswer(index)];
}

function resetQuestionOptions() {
  props.screen.toggles.forEach((t, i) => {
    set(`questionOptions.toggle_${props.screen.id}_${i}_yes`, false);
    set(`questionOptions.toggle_${props.screen.id}_${i}_no`, false);
    set(`completed.toggle_${props.screen.id}_${i}`, false);
  });
}

// the KS has a reset screen button, so listen for the resetting of the screen's completion
watch(
  () => (props.screen.id ? suspend.completed[props.screen.id] : false),
  (newValue, oldValue) => {
    // Only reset if completion changed from true to false
    if (oldValue && !newValue) {
      resetQuestionOptions();
    }
  },
  { flush: 'post' }
);

const app = document.querySelector('#app');
app?.addEventListener('quizReset', async e => {
  if (await isQuizPage(e, pageId)) {
    resetQuestionOptions();
  }
});
</script>
